import { Footer } from "components/footer/footer";
import { Header } from "components/header";
import React from "react";

export default function HelpCenterLayout({ children }) {
  return (
    <div className="min-h-screen bg-white flex flex-col justify-between">
      <div className="w-full">
        <Header isHelpCenter={true} />
        {/* <div className="w-full fixed top-22 left-0 bg-[#ffef86] border-b font-bold text-sm border-gray-300 z-30 h-8 text-black flex items-center px-4">
        Help Center
      </div> */}
        <main className="">{children}</main>
      </div>
      <Footer className="" />
    </div>
  );
}
